import { render, staticRenderFns } from "./AccessDenied.vue?vue&type=template&id=59014c1b&scoped=true&"
import script from "./AccessDenied.vue?vue&type=script&lang=js&"
export * from "./AccessDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59014c1b",
  null
  
)

export default component.exports